// Anchor of the delivery-dates section on the configuration view. Shared so the
// links that deep-link into it cannot drift from the element that carries the
// id — the cart's "Termin dostawy niedostępny" alert sends the user straight
// here, and the form's own validation errors scroll to it too.
export const CALENDAR_SECTION_ID = "cart-calendar";
